function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Modified from: https://github.com/cloudflare/react-gateway/blob/master/src/GatewayRegistry.js
 */
var GatewayRegistry = /*#__PURE__*/function () {
  function GatewayRegistry() {
    _classCallCheck(this, GatewayRegistry);

    _defineProperty(this, "_containers", void 0);

    _defineProperty(this, "_children", void 0);

    _defineProperty(this, "_currentId", void 0);

    this._containers = {};
    this._children = {}; // Unique key for children of a gateway

    this._currentId = 0;
  }

  _createClass(GatewayRegistry, [{
    key: "_renderContainer",
    value: function _renderContainer(name) {
      var _this = this;

      if (!this._containers[name] || !this._children[name]) {
        return;
      }

      this._containers[name].setState({
        children: Object.keys(this._children[name]).sort().map(function (id) {
          return _this._children[name][id];
        })
      });
    }
  }, {
    key: "addContainer",
    value: function addContainer(name, container) {
      this._containers[name] = container;

      this._renderContainer(name);
    }
  }, {
    key: "removeContainer",
    value: function removeContainer(name) {
      this._containers[name] = null;
    }
  }, {
    key: "addChild",
    value: function addChild(name, gatewayId, child) {
      this._children[name][gatewayId] = child;

      this._renderContainer(name);
    }
  }, {
    key: "clearChild",
    value: function clearChild(name, gatewayId) {
      delete this._children[name][gatewayId];
    }
  }, {
    key: "register",
    value: function register(name, child) {
      this._children[name] = this._children[name] || {};
      var gatewayId = "".concat(name, "_").concat(this._currentId);
      this._children[name][gatewayId] = child;
      this._currentId += 1;
      return gatewayId;
    }
  }, {
    key: "unregister",
    value: function unregister(name, gatewayId) {
      this.clearChild(name, gatewayId);

      this._renderContainer(name);
    }
  }]);

  return GatewayRegistry;
}();

export { GatewayRegistry };
